import type { SanityCaseStudy } from '#/lib/sanity/queries/blogPost';
import { cn } from '#/lib/utils';

type CaseStudiesStatsProps = NonNullable<SanityCaseStudy['stats']>;
export function CaseStudiesStats({ stats }: { stats: CaseStudiesStatsProps }) {
  const width = stats.length === 2 ? 'm:w-1/2' : 'm:w-1/3';
  return (
    <section className="bg-electric-02 rounded-24  m:py-33 px-24 l:mb-70 mb-40">
      <div className="flex flex-col m:flex-row justify-between">
        {stats.map((stat, index) => (
          <div
            key={stat._key}
            className={cn(
              'm:px-24 w-full py-24 l:py-0',
              width,
              index !== stats.length - 1
                ? 'm:border-r border-black border-b m:border-b-0'
                : '',
            )}
          >
            <span className="uppercase font-azeret text-12 leading-130 tracking-8 m:mb-50 block">
              {stat.label}
            </span>
            <h2 className="text-28 font-[440] leading-105 -tracking-1 l:text-46 my-4 m:my-0">
              {stat.value}
            </h2>
            <p className="text-14 leading-130 -tracking-2 font-light m:text-24">
              {stat.caption}
            </p>
          </div>
        ))}
      </div>
    </section>
  );
}
